var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcAppContent',[(_vm.currentCollective)?_c('CollectivePrint'):(_vm.loading('collectives'))?_c('NcEmptyContent'):_c('CollectiveNotFound')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }